import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';
import type {
    ActionResponse,
    Volume,
    VolumeCreationRequest,
    VolumeEditationRequest
} from 'typings/portaro.be.types';
import type {AnyObject} from 'typings/portaro.fe.types';
import type {AjaxService} from 'core/data-services/ajax.service';

/**
 * @ngdoc service
 * @name volumeDataService
 * @module portaro.data-services
 *
 *
 * @description
 * Data service for providing volumes of documents
 */
export class VolumeDataService {
    public static serviceName = 'volumeDataService';

    private static readonly VOLUMES_ROUTE = 'volumes';
    private static readonly VOLUMES_CREATE_ROUTE = 'volumes/create';
    private static readonly VOLUMES_DELETE_ROUTE = 'volumes/delete';
    private static readonly VOLUMES_EDIT_ROUTE = 'volumes/edit';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async query(filterParam: AnyObject): Promise<Volume[]> {
        return this.ajaxService
            .createRequest(VolumeDataService.VOLUMES_ROUTE)
            .get(filterParam);
    }

    @ngAsync()
    public async get(volumeId: string): Promise<Volume> {
        return this.ajaxService
            .createRequest(`${VolumeDataService.VOLUMES_ROUTE}/${volumeId}`)
            .get<Volume>();
    }

    @ngAsync()
    public async delete(volumeId: number): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(`${VolumeDataService.VOLUMES_DELETE_ROUTE}`)
            .post(transferify({id: volumeId}));
    }

    @ngAsync()
    public async create(volumeRequest: VolumeCreationRequest): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(VolumeDataService.VOLUMES_CREATE_ROUTE)
            .post(transferify(volumeRequest));
    }

    @ngAsync()
    public async edit(request: VolumeEditationRequest): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(VolumeDataService.VOLUMES_EDIT_ROUTE)
            .post(transferify({...request, confirmed: false}));
    }
}

